"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDisabledAnalyticsInterface = void 0;
const createDisabledAnalyticsInterface = (config) => {
    const analyticsServiceName = "disabled";
    const event = (name, params) => { };
    const set = (key, value) => { };
    const unset = (key) => { };
    const get = (key) => {
        return "";
    };
    return {
        analyticsServiceName,
        event,
        set,
        unset,
        get,
    };
};
exports.createDisabledAnalyticsInterface = createDisabledAnalyticsInterface;
